import { useCallback } from 'react';

import { StatementsFilterModal } from '@xbto/universal-components';
import { DataStore } from '~/store';

type Props = {
  onClose: () => void;
};

export function StatementsFiltersForm({ onClose }: Props) {
  /**
   * Store
   */
  const accountTypeOptions = DataStore.useStoreState(
    s => s.statements.accountTypeOptions
  );
  const dateRangeOptions = DataStore.useStoreState(
    s => s.statements.dateRangeOptions
  );
  const filterAccountType = DataStore.useStoreState(
    s => s.statements.filterAccountType
  );
  const filters = DataStore.useStoreState(s => s.statements.filters);
  const filtersCount = DataStore.useStoreState(s => s.statements.filtersCount);

  const {
    applyFilters,
    clearFilters,
    refreshList,
    setFilterAccountType,
    setFilterDateRange,
  } = DataStore.useStoreActions(a => ({
    applyFilters: a.statements.applyFilters,
    clearFilters: a.statements.clearFilters,
    refreshList: a.statements.refreshListFull,
    setFilterAccountType: a.statements.setFilterAccountType,
    setFilterDateRange: a.statements.setFilterDateRange,
  }));

  /**
   * Handlers
   */
  const handleClearFilters = useCallback(() => {
    clearFilters();
    refreshList();
  }, [clearFilters, refreshList]);

  /**
   * DOM
   */
  return (
    <StatementsFilterModal
      accountType={filterAccountType}
      accountTypeOptions={accountTypeOptions}
      dateRangeId={filters.dateRangeId}
      dateRangeOptions={dateRangeOptions}
      disabled={!filtersCount}
      onApplyFilters={applyFilters}
      onChangeAccountType={setFilterAccountType}
      onChangeDateRange={setFilterDateRange}
      onClearFilters={handleClearFilters}
      onClose={onClose}
    />
  );
}
